import * as types from './_actionTypes';

const initialState = {
  profile: null,
  loading: false,
  updating: false,
  error: null
};

const studentProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_STUDENT_PROFILE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case types.FETCH_STUDENT_PROFILE_SUCCESS:
      return {
        ...state,
        profile: action.payload,
        loading: false,
        error: null
      };
    
    case types.FETCH_STUDENT_PROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        profile: null
      };

    case types.UPDATE_STUDENT_PROFILE_REQUEST:
      return {
        ...state,
        updating: true,
        error: null
      };
    
    case types.UPDATE_STUDENT_PROFILE_SUCCESS:
      return {
        ...state,
        profile: action.payload,
        updating: false,
        error: null
      };
    
    case types.UPDATE_STUDENT_PROFILE_FAILURE:
      return {
        ...state,
        updating: false,
        error: action.payload
      };

    case types.UPDATE_STUDENT_DOB_REQUEST:
      return {
        ...state,
        updating: true,
        error: null
      };
    
    case types.UPDATE_STUDENT_DOB_SUCCESS:
      return {
        ...state,
        profile: {
          ...state.profile,
          dob: action.payload.dob,
          age_years: action.payload.age_years
        },
        updating: false,
        error: null
      };
    
    case types.UPDATE_STUDENT_DOB_FAILURE:
      return {
        ...state,
        updating: false,
        error: action.payload
      };
    
    default:
      return state;
  }
};

export default studentProfileReducer;
